import { render, staticRenderFns } from "./RegistrationStep.vue?vue&type=template&id=0f6a72c8&scoped=true&"
import script from "./RegistrationStep.vue?vue&type=script&lang=js&"
export * from "./RegistrationStep.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationStep.vue?vue&type=style&index=0&id=0f6a72c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a72c8",
  null
  
)

export default component.exports